module.exports = __webpack_public_path__ + "img/07.6cbe26f7.jpg";